import React from "react";
import Pagination from "react-bootstrap/Pagination";
import { useDispatch } from "react-redux";

function PaginationComponent({
  currentPage,
  totalPages,
  setCurrentPage,
  setTotalPages,
  fetchData,
  searchKeyword
}) {
  const dispatch = useDispatch();

  const handlePageChange = (pageNum, limit) => {
    dispatch(setCurrentPage(pageNum));
    let fetchDataParams = { page: pageNum, limit: limit };
    if (searchKeyword) {
      fetchDataParams.keyword = searchKeyword.trim();
    }
    dispatch(fetchData(fetchDataParams));
  };

  const itemsPerPage = 15;
  // const [itemsPerPage, setItemsPerPage] = useState(15);

  // Calculate visible page numbers based on current page
  const calculateVisiblePages = () => {
    const visiblePages = [];
    const maxVisiblePages = 5;

    // Always include the first page
    visiblePages.push(1);

    let startPage = Math.max(2, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 2);

    if (endPage - startPage < maxVisiblePages - 2) {
      startPage = Math.max(2, endPage - maxVisiblePages + 2);
    }

    for (let i = startPage; i <= endPage; i++) {
      visiblePages.push(i);
    }

    return visiblePages;
  };

  return (
    <div className="d-flex justify-content-between mt-4 p-2">
      <div>
        <Pagination>
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1, itemsPerPage)}
          />

          {calculateVisiblePages().map((num, index) => (
            <React.Fragment key={num}>
              {index === 1 && num !== 2 && <Pagination.Ellipsis />}
              <Pagination.Item
                active={num === currentPage}
                onClick={() => handlePageChange(num, itemsPerPage)}
              >
                {num}
              </Pagination.Item>
            </React.Fragment>
          ))}

          {totalPages > 5 && currentPage < totalPages - Math.floor(5 / 2) && (
            <>
              {currentPage < totalPages - Math.floor(5 / 2) && (
                <Pagination.Ellipsis />
              )}
              <Pagination.Item
                onClick={() => handlePageChange(totalPages, itemsPerPage)}
              >
                {totalPages}
              </Pagination.Item>
            </>
          )}

          <Pagination.Next
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1, itemsPerPage)}
          />
        </Pagination>
      </div>
    </div>
  );
}

export default PaginationComponent;
